const TransferTip = () => import('@/views/main/transferTip/TransferTip.vue')
export default {
  path: '/main/transferTip',
  name: 'TransferTip',
  component: TransferTip,
  children: []
}
